import React, { useState } from 'react';
import { FileUploadAndViewer } from '../../../MediaUploadsAndViewer/FileUploadAndViewer';
import { DetailsAccordion } from '../StyledComponents';
import { File, GetAssemblyDetailsQuery } from '@/__generated__/graphql';
import { useSaveAssemblyAttachment } from '../../../hooks/useSaveAssemblyAttachment';

type Props = { referenceId: string; collectionName: string; files: File[]; location?: string, assembly?: GetAssemblyDetailsQuery['assembly'] };

export const MediaUploads = ({ referenceId, collectionName, files, location = '', assembly }: Props) => {
  const [loading, setLoading] = useState(false);
  const { handleCaptureScreenshot } = useSaveAssemblyAttachment(
    referenceId,
    collectionName,
    setLoading
  );

  return (
    <DetailsAccordion title="Attachments" id={`${location}-attachments`}>
      <FileUploadAndViewer
        referenceId={referenceId}
        collectionName={collectionName}
        files={files}
        onCaptureClick={handleCaptureScreenshot}
        loading={loading}
        location={location}
        assembly={assembly}
      />
    </DetailsAccordion>
  );
};
